var GLOBAL_ROLE_OPTIONS = [
  { value: "", label: "Keep the default structure", description: "Best for most sections. Only choose a special meaning when this block truly acts like a named page area." },
  { value: "region", label: "Important page section", description: "Use for a major section people may want to jump to directly." },
  { value: "navigation", label: "Navigation area", description: "Use when this block mainly contains navigation links." },
  { value: "banner", label: "Page header area", description: "Use for the page’s main header area, usually once per page." },
  { value: "complementary", label: "Supporting side content", description: "Use for side content that supports the main page without being the primary focus." },
  { value: "note", label: "Note or callout", description: "Use for editorial notes, notices, or callout content." },
  { value: "presentation", label: "Decorative wrapper", description: "Use only when the wrapper adds layout only and should not add meaning." }
];

var ALLOWED_GLOBAL_ROLES = GLOBAL_ROLE_OPTIONS.map(function(option) {
  return option.value;
});
var ALLOWED_GLOBAL_ROLE_MAP = ALLOWED_GLOBAL_ROLES.reduce(function(map, role) {
  map[role] = true;
  return map;
}, {});

var CLASS_TOKEN_SETS = {
  sectionWrapper: {
    options: [
      { value: "container", label: "Standard page width", description: "Keeps the section aligned to the usual page width.", group: "1. Choose a content width" },
      { value: "container-fluid", label: "Full-width section", description: "Lets this section stretch edge to edge.", group: "1. Choose a content width" },
      { value: "narrow", label: "Reading width", description: "Keeps lines shorter for text-heavy sections.", group: "1. Choose a content width" },
      { value: "py-4", label: "Standard spacing", description: "Adds comfortable top and bottom spacing.", group: "2. Choose spacing" },
      { value: "py-5", label: "Roomy spacing", description: "Adds extra breathing room above and below.", group: "2. Choose spacing" },
      { value: "bg-body", label: "Blend into the page", description: "Keeps the standard page surface and text treatment.", group: "3. Choose a surface style" },
      { value: "bg-body-tertiary", label: "Soft panel", description: "Adds a subtle panel while keeping a safe readable text treatment.", group: "3. Choose a surface style" },
      { value: "bg-dark text-white", label: "Dark panel", description: "Applies a dark panel with matching readable light text.", group: "3. Choose a surface style" },
      { value: "bg-black text-light", label: "Black panel", description: "Applies the darkest panel with a softer light text treatment.", group: "3. Choose a surface style" }
    ],
    exclusiveGroups: [
      ["container", "container-fluid", "narrow"],
      ["py-4", "py-5"],
      ["bg-body", "bg-body-tertiary", "bg-dark text-white", "bg-black text-light"]
    ]
  },
  pageBody: {
    options: [
      { value: "bg-body", label: "Standard page canvas", description: "Default page background and text treatment.", group: "Choose the page canvas" },
      { value: "bg-body-tertiary", label: "Soft page canvas", description: "A softer page background while keeping readable default text.", group: "Choose the page canvas" },
      { value: "bg-dark text-white", label: "Dark page canvas", description: "Dark page background with matching readable light text.", group: "Choose the page canvas" },
      { value: "bg-black text-light", label: "Black page canvas", description: "Black page background with a softer light text treatment.", group: "Choose the page canvas" }
    ],
    exclusiveGroups: [
      ["bg-body", "bg-body-tertiary", "bg-dark text-white", "bg-black text-light"]
    ]
  },
  navRoot: {
    options: [
      { value: "navbar-light bg-white", label: "Light navigation on white", description: "Bright neutral navigation with matching light navbar treatment.", group: "1. Choose the navigation style" },
      { value: "navbar-light bg-body-tertiary", label: "Light navigation on soft background", description: "Soft light navigation treatment with matching readable tone.", group: "1. Choose the navigation style" },
      { value: "navbar-dark bg-dark", label: "Dark navigation", description: "Dark navigation bar with matching readable dark-navbar treatment.", group: "1. Choose the navigation style" },
      { value: "navbar-dark bg-black", label: "Black navigation", description: "Highest-contrast dark navigation option.", group: "1. Choose the navigation style" },
      { value: "border-bottom", label: "Add a bottom divider", description: "Adds a divider line under the navigation bar.", group: "2. Optional finishing touch" },
      { value: "shadow-sm", label: "Add a soft shadow", description: "Adds a gentle lift from the page.", group: "2. Optional finishing touch" }
    ],
    exclusiveGroups: [
      ["navbar-light bg-white", "navbar-light bg-body-tertiary", "navbar-dark bg-dark", "navbar-dark bg-black"]
    ]
  },
  navInner: {
    options: [
      { value: "container", label: "Centered page width", description: "Keeps content aligned to the standard page width.", group: "Width" },
      { value: "container-fluid", label: "Full width", description: "Lets the section stretch edge to edge.", group: "Width" },
      { value: "container-lg", label: "Wide content width", description: "A wider centered container for larger layouts.", group: "Width" },
      { value: "container-xl", label: "Extra-wide content width", description: "The widest centered container in this set.", group: "Width" }
    ],
    exclusiveGroups: [
      ["container", "container-fluid", "container-lg", "container-xl"]
    ]
  }
};

function cloneOptions(list) {
  return (list instanceof Array ? list : []).map(function(option) {
    if (!option || typeof option !== "object") return option;
    return Object.assign({}, option);
  });
}

function getClassTokenSet(optionSetName) {
  return CLASS_TOKEN_SETS[optionSetName] || { options: [], exclusiveGroups: [] };
}

function getAllowedTokenMap(optionSetName) {
  var map = {};
  cloneOptions(getClassTokenSet(optionSetName).options).forEach(function(option) {
    var value = ((option || {}).value || option || "").toString().trim();
    if (value) map[value] = true;
  });
  return map;
}

function normalizeClassName(value) {
  return (value || "").toString().trim().split(/\s+/g).filter(Boolean).join(" ");
}

function normalizeTokenList(value, optionSetName) {
  if (value instanceof Array) {
    return value.map(function(item) {
      return normalizeClassName(item);
    }).filter(Boolean);
  }

  var normalized = normalizeClassName(value);
  if (!normalized) return [];

  var optionSet = getClassTokenSet(optionSetName);
  var phraseOptions = cloneOptions(optionSet.options).map(function(option) {
    return normalizeClassName((option && option.value) || option || "");
  }).filter(Boolean).sort(function(a, b) {
    return b.length - a.length;
  });

  var remaining = normalized;
  var matched = [];
  while (remaining) {
    var found = "";
    for (var i = 0; i < phraseOptions.length; i++) {
      var candidate = phraseOptions[i];
      if (remaining === candidate || remaining.indexOf(candidate + " ") === 0) {
        found = candidate;
        break;
      }
    }
    if (found) {
      matched.push(found);
      remaining = normalizeClassName(remaining.slice(found.length));
      continue;
    }
    var parts = remaining.split(/\s+/g);
    matched.push(parts[0]);
    remaining = normalizeClassName(parts.slice(1).join(" "));
  }
  return matched.filter(Boolean);
}

function collapseExclusiveGroups(optionSetName, tokens) {
  var groups = getClassTokenSet(optionSetName).exclusiveGroups || [];
  var normalized = [];
  for (var i = 0; i < (tokens || []).length; i++) {
    var token = (tokens[i] || "").toString().trim();
    if (!token) continue;
    for (var g = 0; g < groups.length; g++) {
      if (groups[g].indexOf(token) >= 0) {
        normalized = normalized.filter(function(existing) {
          return groups[g].indexOf(existing) === -1;
        });
        break;
      }
    }
    if (normalized.indexOf(token) === -1) normalized.push(token);
  }
  return normalized;
}

function sanitizeClassTokens(value, optionSetName) {
  var allowed = getAllowedTokenMap(optionSetName);
  return collapseExclusiveGroups(optionSetName, normalizeTokenList(value, optionSetName).filter(function(token) {
    return !!allowed[token];
  })).join(" ");
}

function sanitizeGlobalRole(value) {
  var role = (value || "").toString().trim();
  return ALLOWED_GLOBAL_ROLE_MAP[role] ? role : "";
}

function validateClassTokensInput(value, optionSetName, label) {
  if (value === undefined) return { valid: true, errors: [] };
  if (!(typeof value === "string" || value instanceof Array)) {
    return { valid: false, errors: [(label || "Visual style choices") + " must be saved as selected style choices."] };
  }
  var normalized = normalizeClassName((value instanceof Array ? value.map(normalizeClassName).filter(Boolean).join(" ") : value) || "");
  if (sanitizeClassTokens(value, optionSetName) !== normalized) {
    return { valid: false, errors: [(label || "Visual style choices") + " include a choice outside the approved list for this area."] };
  }
  return { valid: true, errors: [] };
}

function composeClassTokens(optionSetName, selectedValue, fallbackValue) {
  var selectedTokens = sanitizeClassTokens(selectedValue, optionSetName);
  if (selectedTokens) return selectedTokens;
  return sanitizeClassTokens(fallbackValue, optionSetName);
}

function buildClassTokenDescription() {
  return "Choose from the guided style groups below. Pick one option where a group offers alternatives, then add optional finishing touches where offered.";
}

function buildClassSelectionField(title, optionSetName, description) {
  return {
    title: title,
    type: "class.tokens",
    options: cloneOptions(getClassTokenSet(optionSetName).options),
    exclusiveGroups: cloneOptions(getClassTokenSet(optionSetName).exclusiveGroups),
    description: description || buildClassTokenDescription()
  };
}

function buildGlobalAttributesField(title, description, optionSetName) {
  return {
    title: title || "Section settings",
    type: "object",
    dialog: true,
    description: description || "Guided section settings for appearance, links, visibility, and optional accessibility refinements.",
    classTokenSet: optionSetName || "sectionWrapper",
    groups: [
      {
        title: "Style",
        description: "Choose the look of this section using guided presets and grouped options.",
        fields: ["className"]
      },
      {
        title: "Links & hover text",
        description: "Optional editor-facing page hooks. Leave these blank unless you need them.",
        fields: ["id", "title"]
      },
      {
        title: "Accessibility & structure",
        description: "Only use these when this section needs a clearer purpose for assistive technology.",
        fields: ["role", "ariaLabel"]
      },
      {
        title: "Visibility",
        description: "Hiding a section removes it from the live page for visitors.",
        fields: ["hidden"]
      }
    ],
    fields: {
      id: {
        title: "Jump link ID",
        type: "string",
        description: "Optional short label used for trusted jump links. Leave blank unless something needs to link here directly."
      },
      title: {
        title: "Hover hint",
        type: "string",
        description: "Optional helper text that may appear on hover in some browsers. Usually best left blank."
      },
      role: {
        title: "Section purpose",
        type: "string",
        options: cloneOptions(GLOBAL_ROLE_OPTIONS),
        editorControl: "group",
        description: "Most sections should keep the default structure. Choose a special purpose only when it clearly matches the content."
      },
      ariaLabel: {
        title: "Spoken label",
        type: "string",
        description: "Optional spoken label for assistive technology when the section purpose is not already obvious from visible text."
      },
      hidden: {
        title: "Hide this section from visitors",
        type: "boolean",
        description: "Use with care. When turned on, this section is removed from the live page and visitors cannot see or use it."
      },
      className: buildClassSelectionField("Section style", optionSetName || "sectionWrapper", "Follow the guided choices below: pick one option in each main group, then optionally add finishing touches where offered.")
    }
  };
}

function validateGlobalAttributesInput(attrs, optionSetName) {
  if (attrs === undefined) return { valid: true, errors: [] };
  if (!(attrs && typeof attrs === "object") || attrs instanceof Array) {
    return { valid: false, errors: ["These section settings need to be saved as a structured object."] };
  }

  var allowedKeys = {
    id: true,
    title: true,
    role: true,
    ariaLabel: true,
    hidden: true,
    className: true
  };
  var errors = [];

  Object.keys(attrs).forEach(function(key) {
    if (!(allowedKeys[key])) errors.push('"' + key + '" is not an editable setting in this panel.');
  });

  ["id", "title", "ariaLabel"].forEach(function(key) {
    if (attrs[key] !== undefined && typeof attrs[key] !== "string") errors.push(key + " must be entered as text.");
  });

  if (attrs.role !== undefined) {
    if (typeof attrs.role !== "string") errors.push("Section meaning must be chosen from the provided options.");
    else if (sanitizeGlobalRole(attrs.role) !== (attrs.role || "").toString().trim()) errors.push("Choose a section meaning from the guided landmark choices.");
  }

  if (attrs.hidden !== undefined && typeof attrs.hidden !== "boolean") {
    errors.push("Hide this section must be turned on or off.");
  }

  if (attrs.className !== undefined) {
    errors = errors.concat(validateClassTokensInput(attrs.className, optionSetName || "sectionWrapper", "Visual style choices").errors);
  }

  return { valid: errors.length === 0, errors: errors };
}

function sanitizeGlobalAttributes(attrs, optionSetName) {
  var source = attrs && typeof attrs === "object" ? attrs : {};
  return {
    id: (source.id || "").toString().trim(),
    title: (source.title || "").toString().trim(),
    role: sanitizeGlobalRole(source.role),
    ariaLabel: (source.ariaLabel || source["aria-label"] || "").toString().trim(),
    hidden: source.hidden === true,
    className: sanitizeClassTokens(source.className || source.c || source.class, optionSetName || "sectionWrapper")
  };
}

function extractGlobalAttributes(node, optionSetName) {
  var source = node && typeof node === "object" ? node : {};
  return sanitizeGlobalAttributes({
    id: source.id,
    title: source.title,
    role: source.role,
    ariaLabel: source["aria-label"],
    hidden: source.hidden,
    className: source.c || source.class
  }, optionSetName);
}

function validatePersistedGlobalAttributes(node, optionSetName, classProp) {
  var source = node && typeof node === "object" ? node : {};
  var prop = classProp || "c";
  var allowedKeys = { id: true, title: true, role: true, hidden: true, "aria-label": true };
  allowedKeys[prop] = true;
  var keys = Object.keys(source).filter(function(key) {
    return allowedKeys[key];
  });
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (key === "hidden") {
      if (source.hidden !== true) return { valid: false, reason: "Hide this section can only be saved as on when present." };
      continue;
    }
    if (key === prop) {
      if (sanitizeClassTokens(source[key], optionSetName || "sectionWrapper") !== normalizeClassName(source[key])) {
        return { valid: false, reason: "One or more visual style choices are outside the approved list for this field." };
      }
      continue;
    }
    if (typeof source[key] !== "string") return { valid: false, reason: key + " must be saved as text when present." };
    if (key === "role" && sanitizeGlobalRole(source[key]) !== (source[key] || "").toString().trim()) {
      return { valid: false, reason: "Section meaning must be one of the approved landmark choices." };
    }
  }
  return { valid: true };
}

function applyGlobalAttributes(target, attrs, options) {
  var out = target && typeof target === "object" ? target : {};
  var opts = options && typeof options === "object" ? options : {};
  var classProp = opts.classProp || "c";
  var optionSetName = opts.optionSetName || "sectionWrapper";
  var fallbackClassName = normalizeClassName(opts.fallbackClassName || "");
  var clean = sanitizeGlobalAttributes(attrs, optionSetName);
  var className = composeClassTokens(optionSetName, clean.className, fallbackClassName);

  if (clean.id) out.id = clean.id;
  else delete out.id;

  if (clean.title) out.title = clean.title;
  else delete out.title;

  if (clean.role) out.role = clean.role;
  else delete out.role;

  if (clean.ariaLabel) out["aria-label"] = clean.ariaLabel;
  else delete out["aria-label"];

  if (clean.hidden === true) out.hidden = true;
  else delete out.hidden;

  if (className) out[classProp] = className;
  else delete out[classProp];

  return out;
}

module.exports = {
  CLASS_TOKEN_OPTIONS: Object.keys(CLASS_TOKEN_SETS).reduce(function(out, key) {
    out[key] = cloneOptions(CLASS_TOKEN_SETS[key].options);
    return out;
  }, {}),
  CLASS_TOKEN_SETS: CLASS_TOKEN_SETS,
  buildClassSelectionField: buildClassSelectionField,
  buildGlobalAttributesField: buildGlobalAttributesField,
  sanitizeClassTokens: sanitizeClassTokens,
  validateClassTokensInput: validateClassTokensInput,
  validateGlobalAttributesInput: validateGlobalAttributesInput,
  sanitizeGlobalAttributes: sanitizeGlobalAttributes,
  extractGlobalAttributes: extractGlobalAttributes,
  validatePersistedGlobalAttributes: validatePersistedGlobalAttributes,
  applyGlobalAttributes: applyGlobalAttributes,
  composeClassTokens: composeClassTokens,
  normalizeClassName: normalizeClassName,
  GLOBAL_ROLE_OPTIONS: cloneOptions(GLOBAL_ROLE_OPTIONS),
  ALLOWED_GLOBAL_ROLES: ALLOWED_GLOBAL_ROLES,
  sanitizeGlobalRole: sanitizeGlobalRole
};
